module.exports = __webpack_public_path__ + "img/calendar-24_fill.3119f615.svg";